export default __webpack_public_path__ + "static/media/resume.9192c0cf.pdf";